"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../../../constants/vars"));

var _breakpoints = _interopRequireDefault(require("../../../../constants/breakpoints"));

var _ChevronUp = _interopRequireDefault(require("../../../Icons/ChevronUp"));

var _ChevronDown = _interopRequireDefault(require("../../../Icons/ChevronDown"));

var _ChevronDoubleUp = _interopRequireDefault(require("../../../Icons/ChevronDoubleUp"));

var _ChevronDoubleDown = _interopRequireDefault(require("../../../Icons/ChevronDoubleDown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\ttop: 4px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\ttop: -4px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: center;\n\tuser-select: none;\n\n\tsvg {\n\t\tcursor: pointer;\n\t}\n\n\tsvg:nth-child(2) {\n\t\tmargin-left: ", ";\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder: 2px solid ", ";\n\tborder-radius: ", ";\n\toutline: none;\n\twidth: 60px;\n\ttext-align: center;\n\tmargin: ", " 0;\n\tpadding: ", " 0;\n\n\t@media (min-width: ", ") {\n\t\twidth: 100px;\n\t\tfont-size: ", ";\n\t\tpadding: ", " 0;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var TimePartInput = _styledComponents.default.input(_templateObject(), _colors.default.borderColor, _vars.default.borderRadius, _spacing.default.s1, _spacing.default.s1, _breakpoints.default.tablet, _spacing.default.s3, _spacing.default.s2);

TimePartInput.displayName = 'TimePartInput';

var IncrementButtons = _styledComponents.default.div(_templateObject2(), _spacing.default.s2);

IncrementButtons.displayName = 'IncrementButtons';
var StyledChevronDoubleUpIcon = (0, _styledComponents.default)(_ChevronDoubleUp.default)(_templateObject3());
StyledChevronDoubleUpIcon.displayName = 'StyledChevronDoubleUpIcon';
var StyledChevronDoubleDownIcon = (0, _styledComponents.default)(_ChevronDoubleDown.default)(_templateObject4());
StyledChevronDoubleDownIcon.displayName = 'StyledChevronDoubleDownIcon';

var parseIncrements = function parseIncrements(increment) {
  if (Array.isArray(increment)) return increment; // only small increment specified, auto for large

  var largeIncrement = function largeIncrement() {
    if (increment < 2) {
      return 10;
    }

    if (increment > 2 && increment < 10) {
      return increment * 3;
    }

    return increment * 2;
  };

  return [increment, largeIncrement()];
};

var UnitInput = function UnitInput(_ref) {
  var value = _ref.value,
      unit = _ref.unit,
      onChange = _ref.onChange,
      onIncrement = _ref.onIncrement,
      showLargeIncrements = _ref.showLargeIncrements,
      increment = _ref.increment;
  var formatNumber = (0, _react.useCallback)(function (v) {
    return unit === 'minutes' ? v.toString().padStart(2, '0') : v;
  }, [unit]);

  var _useState = (0, _react.useState)(formatNumber(value)),
      rawValue = _useState[0],
      setRawValue = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      hasFocus = _useState2[0],
      setFocus = _useState2[1];

  (0, _react.useEffect)(function () {
    setRawValue(formatNumber(value));
  }, [value, formatNumber]);

  var _parseIncrements = parseIncrements(increment),
      smallIncrement = _parseIncrements[0],
      largeIncrement = _parseIncrements[1];

  var updateHandler = function updateHandler(newRawValue, shouldAccept) {
    if (shouldAccept === void 0) {
      shouldAccept = false;
    }

    var newValue = parseInt(newRawValue, 10);

    if (!Number.isNaN(newValue) && Number.isFinite(newValue)) {
      onChange(newValue, shouldAccept);
    } else {
      // not valid so set raw value back to last known good
      setRawValue(formatNumber(value));
    }
  };

  return _react.default.createElement("div", null, _react.default.createElement(IncrementButtons, null, showLargeIncrements && _react.default.createElement(StyledChevronDoubleUpIcon, {
    role: "spinbutton",
    size: 16,
    color: _colors.default.primary,
    onClick: function onClick() {
      return onIncrement(largeIncrement);
    }
  }), _react.default.createElement(_ChevronUp.default, {
    role: "spinbutton",
    size: 16,
    color: _colors.default.primary,
    onClick: function onClick() {
      return onIncrement(smallIncrement);
    }
  })), _react.default.createElement(TimePartInput, {
    name: unit,
    value: hasFocus ? rawValue : formatNumber(value),
    onChange: function onChange(e) {
      return setRawValue(e.target.value);
    },
    onFocus: function onFocus() {
      return setFocus(true);
    },
    onBlur: function onBlur(e) {
      setFocus(false);
      updateHandler(e.target.value);
    },
    onKeyDown: function onKeyDown(v) {
      if (v.keyCode === 13) {
        v.preventDefault();
        updateHandler(rawValue, true);
      }

      var amount = showLargeIncrements && v.shiftKey ? largeIncrement : smallIncrement;

      if (v.keyCode === 38) {
        // up arrow
        onIncrement(amount);
      }

      if (v.keyCode === 40) {
        onIncrement(-amount);
      }
    },
    maxLength: unit === 'minutes' ? 2 : 4,
    "data-e2e": "time-" + unit
  }), _react.default.createElement(IncrementButtons, null, showLargeIncrements && _react.default.createElement(StyledChevronDoubleDownIcon, {
    role: "spinbutton",
    size: 16,
    color: _colors.default.primary,
    onClick: function onClick() {
      return onIncrement(-largeIncrement);
    }
  }), _react.default.createElement(_ChevronDown.default, {
    role: "spinbutton",
    size: 16,
    color: _colors.default.primary,
    onClick: function onClick() {
      return onIncrement(-smallIncrement);
    }
  })));
};

UnitInput.propTypes = {
  value: _propTypes.number.isRequired,
  unit: (0, _propTypes.oneOf)(['days', 'hours', 'minutes', 'seconds']).isRequired,
  onChange: _propTypes.func.isRequired,
  onIncrement: _propTypes.func.isRequired,
  showLargeIncrements: _propTypes.bool,
  increment: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.number), _propTypes.number])
};
UnitInput.defaultProps = {
  showLargeIncrements: false,
  increment: 1
};
var _default = UnitInput;
exports.default = _default;